import {
  PLAYER_POOLING_PERIOD_WHILE_UNREGISTERED_MS,
  PLAYER_POOLING_UNREGISTERED_FAST_WINDOW_MS,
  PLAYER_POOLING_UNREGISTERED_MID_MS,
  PLAYER_POOLING_UNREGISTERED_MID_UNTIL_MS,
  PLAYER_POOLING_UNREGISTERED_SLOW_MS
} from '../constants/player'

/**
 * Unregistered registration-poll interval with staged backoff + jitter.
 * Fast (2s) for the first {@link PLAYER_POOLING_UNREGISTERED_FAST_WINDOW_MS}, then mid, then slow.
 */
export function computeUnregisteredPoolingPeriodMs(
  unregisteredForMs: number,
  random: () => number = Math.random
): number {
  let baseMs = PLAYER_POOLING_PERIOD_WHILE_UNREGISTERED_MS
  if (unregisteredForMs >= PLAYER_POOLING_UNREGISTERED_MID_UNTIL_MS) {
    baseMs = PLAYER_POOLING_UNREGISTERED_SLOW_MS
  }
  else if (unregisteredForMs >= PLAYER_POOLING_UNREGISTERED_FAST_WINDOW_MS) {
    baseMs = PLAYER_POOLING_UNREGISTERED_MID_MS
  }
  // ±20% jitter so a fleet of orphaned devices does not sync up.
  const jitter = 0.8 + random() * 0.4
  return Math.max(PLAYER_POOLING_PERIOD_WHILE_UNREGISTERED_MS, Math.round(baseMs * jitter))
}
